import { useEffect, useRef } from "react";

interface UseOutsidePointerDownOptions {
  enabled: boolean;
  protectedSelector: string;
  eventType?: "mousedown" | "pointerdown";
  onOutside: () => void;
}

export function useOutsidePointerDown({
  enabled,
  protectedSelector,
  eventType = "pointerdown",
  onOutside,
}: UseOutsidePointerDownOptions) {
  const onOutsideRef = useRef(onOutside);
  onOutsideRef.current = onOutside;

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const handleOutside = (event: MouseEvent | PointerEvent) => {
      const target =
        event.target instanceof Element
          ? event.target
          : event.target instanceof Node
            ? event.target.parentElement
            : null;
      if (target?.closest(protectedSelector)) {
        return;
      }
      onOutsideRef.current();
    };
    window.addEventListener(eventType, handleOutside, { capture: true });
    return () => window.removeEventListener(eventType, handleOutside, { capture: true });
  }, [enabled, eventType, protectedSelector]);
}
